var map = {
  "./desktop/CBSE.scss": [
    "61447",
    7,
    "34068"
  ],
  "./desktop/index.js": [
    "28238",
    9,
    "76225",
    "62815",
    "57788",
    "47387",
    "3199",
    "77996",
    "50437",
    "21007",
    "45127",
    "92625",
    "74151",
    "52377",
    "80359",
    "14253"
  ],
  "./desktop/index": [
    "28238",
    9,
    "76225",
    "62815",
    "57788",
    "47387",
    "3199",
    "77996",
    "50437",
    "21007",
    "45127",
    "92625",
    "74151",
    "52377",
    "80359",
    "14253"
  ],
  "./mobile/CBSE.scss": [
    "61723",
    7,
    "7258"
  ],
  "./mobile/CBSE.js": [
    "83854",
    9,
    "80359",
    "54627",
    "48793"
  ],
  "./mobile/index.js": [
    "72220",
    9,
    "14952",
    "47387",
    "3199",
    "77996",
    "68454",
    "44944",
    "17189",
    "80359",
    "54627",
    "86759"
  ],
  "./mobile": [
    "72220",
    9,
    "14952",
    "47387",
    "3199",
    "77996",
    "68454",
    "44944",
    "17189",
    "80359",
    "54627",
    "86759"
  ],
  "./desktop": [
    "28238",
    9,
    "76225",
    "62815",
    "57788",
    "47387",
    "3199",
    "77996",
    "50437",
    "21007",
    "45127",
    "92625",
    "74151",
    "52377",
    "80359",
    "14253"
  ],
  "./desktop/": [
    "28238",
    9,
    "76225",
    "62815",
    "57788",
    "47387",
    "3199",
    "77996",
    "50437",
    "21007",
    "45127",
    "92625",
    "74151",
    "52377",
    "80359",
    "14253"
  ],
  "./mobile/": [
    "72220",
    9,
    "14952",
    "47387",
    "3199",
    "77996",
    "68454",
    "44944",
    "17189",
    "80359",
    "54627",
    "86759"
  ],
  "./desktop/CBSE": [
    "2568",
    9,
    "80359",
    "56959"
  ],
  "./desktop/CBSE.js": [
    "2568",
    9,
    "80359",
    "56959"
  ],
  "./mobile/CBSE": [
    "83854",
    9,
    "80359",
    "54627",
    "48793"
  ],
  "./mobile/index": [
    "72220",
    9,
    "14952",
    "47387",
    "3199",
    "77996",
    "68454",
    "44944",
    "17189",
    "80359",
    "54627",
    "86759"
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
    return __webpack_require__.t(id, ids[1] | 16);
  });
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 52173;
module.exports = __rspack_async_context;
